import { CircularProgress, Typography } from '@mui/material';
import './TitledCircularProgress.css';

function TitledCircularProgress({ title }) {
  return (
    <div className="titled-circular-progress" style={{ paddingTop: '20px' }}>
      <Typography variant="h6" style={{ fontFamily: 'Arial' }}>
        {title}
      </Typography>
      <CircularProgress />
    </div>
  );
}

export { TitledCircularProgress };
